import classes from "./Meals.module.css";
import MealsList from "./MealsList";

const Meals = () => {
  return (
    <section className={classes.summary}>
      <h2>Delicious Food At You Finger Tip</h2>
      <p>
        This is a Cloud Kitchen serving very delicious food in an affordable
        price, in your neighborhood. We serve a variety of food. We maintain
        proper hygiene in our food and cook with care. So you will definitely
        enjoy our food
      </p>
      <MealsList />
    </section>
  );
};
export default Meals;
